import { render, staticRenderFns } from "./SurfacePostBody.vue?vue&type=template&id=0baf6761&scoped=true&"
import script from "./SurfacePostBody.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostBody.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostBody.vue?vue&type=style&index=0&id=0baf6761&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf6761",
  null
  
)

export default component.exports